// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"3fe370e5","659":"04cb49ed"}[chunkId] + ".chunk.js";
};